import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FORM_TEMPLATES_REQUEST } from "./types";

interface FormTemplatesState {
  loading: boolean;
  error: any | null;
  allFormTemplates: any[];
  formTemplateDetails: any | null;
  formTemplateDocument: any | null;
  formSections: any[];
  definedNames: any[];
  formTemplateList: any[];
  photoLayouts: any[] | null;
}

const formTemplatesInitialState: FormTemplatesState = {
  loading: false,
  error: null,
  allFormTemplates: [],
  formTemplateDetails: null,
  formTemplateDocument: null,
  formSections: [],
  definedNames: [],
  formTemplateList: [],
  photoLayouts: null,
};

export const formTemplatesSlice = createSlice({
  name: FORM_TEMPLATES_REQUEST,
  initialState: formTemplatesInitialState,
  reducers: {
    getAllFormTemplatesRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    getAllFormTemplatesSuccess(
      state,
      action: PayloadAction<{ response: any }>
    ) {
      state.loading = false;
      state.allFormTemplates = action.payload.response;
    },
    getAllFormTemplatesFailure(state, action: PayloadAction<{ error: any }>) {
      state.loading = false;
      state.error = action.payload.error;
    },
    getFormTemplateDetailsRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    getFormTemplateDetailsSuccess(
      state,
      action: PayloadAction<{ response: any }>
    ) {
      state.loading = false;
      state.formTemplateDetails = action.payload.response;
    },
    getFormTemplateDetailsFailure(
      state,
      action: PayloadAction<{ error: any }>
    ) {
      state.loading = false;
      state.error = action.payload.error;
    },
    getFormTemplateDocumentRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    getFormTemplateDocumentSuccess(
      state,
      action: PayloadAction<{ response: any }>
    ) {
      state.loading = false;
      state.formTemplateDocument = action.payload.response;
    },
    getFormTemplateDocumentFailure(
      state,
      action: PayloadAction<{ error: any }>
    ) {
      state.loading = false;
      state.error = action.payload.error;
    },
    getFormSectionsRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    getFormSectionsSuccess(state, action: PayloadAction<{ response: any }>) {
      state.loading = false;
      state.formSections = action.payload.response;
    },
    getFormSectionsFailure(state, action: PayloadAction<{ error: any }>) {
      state.loading = false;
      state.error = action.payload.error;
    },
    getDefinedNamesRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    getDefinedNamesSuccess(state, action: PayloadAction<{ response: any }>) {
      state.loading = false;
      state.definedNames = action.payload.response;
    },
    getDefinedNamesFailure(state, action: PayloadAction<{ error: any }>) {
      state.loading = false;
      state.error = action.payload.error;
    },
    getFormTemplateListRequest(state) {
      state.loading = true;
      state.error = null;
    },
    getFormTemplateListSuccess(
      state,
      action: PayloadAction<{ response: any }>
    ) {
      state.loading = false;
      state.formTemplateList = action.payload.response;
    },
    getFormTemplateListFailure(state, action: PayloadAction<{ error: any }>) {
      state.loading = false;
      state.error = action.payload.error;
    },
    getPhotoLayoutsRequest(state) {
      state.loading = true;
      state.error = null;
    },
    getPhotoLayoutsSuccess(state, action: PayloadAction<{ response: any }>) {
      state.loading = false;
      state.photoLayouts = action.payload.response;
    },
    getPhotoLayoutsFailure(state, action: PayloadAction<{ error: any }>) {
      state.loading = false;
      state.error = action.payload.error;
    },
  },
});

export const {
  getAllFormTemplatesRequest,
  getAllFormTemplatesSuccess,
  getAllFormTemplatesFailure,
  getFormTemplateDetailsRequest,
  getFormTemplateDetailsSuccess,
  getFormTemplateDetailsFailure,
  getFormTemplateDocumentRequest,
  getFormTemplateDocumentSuccess,
  getFormTemplateDocumentFailure,
  getFormSectionsRequest,
  getFormSectionsSuccess,
  getFormSectionsFailure,
  getDefinedNamesRequest,
  getDefinedNamesSuccess,
  getDefinedNamesFailure,
  getFormTemplateListRequest,
  getFormTemplateListSuccess,
  getFormTemplateListFailure,
  getPhotoLayoutsRequest,
  getPhotoLayoutsSuccess,
  getPhotoLayoutsFailure,
} = formTemplatesSlice.actions;
export default formTemplatesSlice.reducer;
